import React from "react";

const ClientPage = (props) => {
	return <div>{props.children}</div>;
};

export default ClientPage;
